import { render, staticRenderFns } from "./Home_noticias.vue?vue&type=template&id=26e5031f&scoped=true&"
import script from "./Home_noticias.vue?vue&type=script&lang=js&"
export * from "./Home_noticias.vue?vue&type=script&lang=js&"
import style0 from "./Home_noticias.vue?vue&type=style&index=0&id=26e5031f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e5031f",
  null
  
)

export default component.exports